import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const Donation = ({ image }) => {
  return (
    <Wrapper>
      <GatsbyImage image={getImage(image)} alt="Flowers" />
      <TextBox>
        <h2>Make a Donation</h2>
        <h3>We support people living with Parkinson's Disease!</h3>
        <p><span>1800 359 359</span> - Free Phone Support Line</p>
      </TextBox>
      <a
        href="https://forms.zohopublic.eu/theparkinsonsassociationofir/form/OnlineDonation/formperma/rP47LiePjVnL9SQRlkMbbTRWHCTjXF031ExfT2TN0b8"
        target="_blank"
        rel="noreferrer"
      >
        <Button
          type="button"
          whileHover={{ scale: 1.025 }}
          whileTap={{ scale: 0.95 }}
        >
          <h2>Donate</h2>
        </Button>
      </a>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  padding: 2.5rem 1.25rem;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 1.5rem;
  color: var(--abbvie-green);
  background: white;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.2);
  width: 98%;
  max-width: 1240px;
  margin: 3.5rem auto 1.5rem;
  position: relative;
  box-sizing: border-box;
  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
  }
  @media (min-width: 768px) {
    gap: 2rem;
    justify-content: space-between;
    flex-direction: row;
    padding: 2.5rem 5rem;
  }
`;

const TextBox = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  max-width: 780px;
  position: relative;
  font-style: normal;
  z-index: 3;
  h2 {
    margin-bottom: 0.15em;
    font-size: 1.75rem;
    font-family: "League Spartan", sans-serif;
    color: var(--abbvie-bright-green);
    font-weight: 400 !important;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }
  h3 {
    font-family: "League Spartan", sans-serif;
    font-size: 1.25rem;
    letter-spacing: 0.5px;
    text-align: center;
    margin-bottom: 1rem;
    font-weight: 900;
    color: var(--abbvie-green);
  }
  p {
    font-family: "League Spartan", sans-serif;
    color: var(--abbvie-blue);
    font-weight: 600;
    font-size: 1.25rem;
    line-height: 32px;
    text-align: center;
    span {
      font-weight: 900;
    }
  }
  @media (min-width: 768px) {
    align-items: flex-start;
    h3 {
      font-size: 1.5rem;
      text-align: left;
    }
    p {
      font-size: 1.25rem;
    }
  }
  @media (min-width: 1150px) {
    h2 {
      font-size: 2rem;
      line-height: 2.125rem;
    }
    p {
      font-size: 1.25rem;
    }
  }
`;

const Button = styled(motion.button)`
  background: var(--abbvie-blue);
  cursor: pointer;
  text-transform: uppercase;
  padding: 1rem 2.375rem;
  position: relative;
  z-index: 3;
  h2 {
    color: white;
    font-weight: normal;
    font-family: "League Spartan", sans-serif;
    font-weight: 900;
    font-size: 1.25rem;
  }
  @media (min-width: 768px) {
    font-size: 1.875rem;
    margin-right: 10rem;
  }
`;

export default Donation;
